module.exports = __webpack_public_path__ + "assets/f4bc7ac15f0db226ab3491fab05f6ddf.png";